module.exports = __webpack_public_path__ + "static/media/cd.b8331cdf.svg";